import React from 'react';
const Notfound = () => <h1>Page Not found</h1>;
export default Notfound;